import { BookOpen } from 'lucide-react';

/**
 * Says that the passage this question belongs to is one of several alternatives.
 *
 * Kept apart from `ChoiceGroupBanner`, which is about a choice *between these questions*.
 * A passage in a group makes the whole block optional — every question in it, grouped or
 * not — so the wording has to be about the block, or a student reads "attempt any 1 of 2"
 * on an ordinary sub-question and thinks it is one of two interchangeable questions.
 */
const PassageChoiceNote = ({ group }) => {
  if (!group) return null;

  return (
    <div className="mb-4 rounded-lg border border-indigo-200 bg-indigo-50 px-3 py-2.5">
      <div className="flex items-center gap-2">
        <BookOpen className="h-4 w-4 flex-shrink-0 text-indigo-600" />
        <p className="text-sm font-medium text-indigo-900">
          This passage is one of {(group.questions || []).length} alternatives
        </p>
      </div>
    </div>
  );
};

export default PassageChoiceNote;
